import React, { Component } from 'react';
import Box from '@mui/material/Box';
import $ from 'jquery';

export default class Q3 extends Component {
	
	constructor(props) {
        super(props);
        this.state = { value: [''] }
        this.shoot = this.shoot.bind(this); 
    }

    shoot(event) {
        var resArray = Array.from(event.target.selectedOptions, (item) => item.value)
        var sh =resArray.toString();
        this.setState({value: Array.from(event.target.selectedOptions, (item) => item.value)});
        this.props.func(this.props.data.fieldId,sh)
        this.setState({value:['']});
    }
   
    render() {
        const {data} = this.props;
        let id = data.fieldId;
		let options = data.options.split(',');
		let kioskResponse = data.kioskResponse;
		
        var newArray  =[];
        if(kioskResponse.size > 0){
            var multiRes = kioskResponse.get(id);
            if(multiRes !== undefined){
                newArray = multiRes.split(',')
            }
        }
		let optionsHtml = '';
        if(options){
            optionsHtml = options.map(function(val,i) {
				let optionKey = val.split('|');
                if(newArray.indexOf(optionKey[1]) !== -1){
                    return (
                        <option value={optionKey[1]} selected key={i}>{optionKey[1]}</option>
                    );  
                }else{
                    return (
                        <option value={optionKey[1]} key={i}>{optionKey[1]}</option>
                    );
                }
            })
        }
		
		return (<Box><select className="form-control" multiple={true} onChange={this.shoot}>
			{optionsHtml}
		</select></Box>);
    }
}
